import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/services/penetration-testing/PenetrationTestingClient.tsx");
